import React, { useState } from "react";
import { Users, Award, Activity, CheckCircle, Phone } from "react-feather";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { sendMail } from "../../api/mailAPI";
import { showToast } from "../../components/ToastifyNotification";

const schema = yup.object().shape({
  doctorName: yup.string().required("Doctor/Hospital Name is required"),
  speciality: yup.string().required("Speciality is required"),
  mobile: yup
    .string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Enter valid 10 digit mobile number"),
  businessType: yup.string().required("Business Type is required"),
  // email: yup
  //     .string()
  //     .required("Email is required")
  //     .email("Invalid email format"),
  website: yup.string().nullable(),
  message: yup.string().nullable(),
  terms: yup.bool().oneOf([true], "Please accept terms and conditions")
});

const HeroSection = () => {
  const [loading, setLoading] = useState(false);
  // ✅ React Hook Form
  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  // ✅ Submit
  const onSubmit = async data => {
    setLoading(true);
    const emailBody = `
          <h3>New Request for Free Trial Received</h3>
          <p><b>Doctor/Hospital:</b> ${data.doctorName}</p>
          <p><b>Speciality:</b> ${data.speciality}</p>
          <p><b>Mobile:</b> ${data.mobile}</p>
          <p><b>Business Type:</b> ${data.businessType}</p>
          <p><b>Email:</b> ${data.email}</p>
          <p><b>Website:</b> ${data.website}</p>
          <p><b>Message:</b> ${data.message}</p>
          `;

    try {
      const response = await sendMail({
        subject: "New Request for Free Trial Received",
        html: emailBody
      });

      if (response.success) {
        showToast("success", "Request sent successfully!");
        reset();
      } else {
        showToast("error", "Something went wrong!");
      }
    } catch (error) {
      showToast("error", "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      className="py-5 text-white"
      style={{
        // backgroundImage:
        //   "url('https://images.unsplash.com/photo-1586773860418-d37222d8fce3')",
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7 mb-4">
            <span
              className="badge mb-3 px-3 py-2 lanp-bg-primary rounded-pill fw-bolder"
              data-aos="zoom-in"
            >
              Hospital Management Software
            </span>

            <h1 className="fw-bold display-5 text-dark" data-aos="zoom-in">
              Smart <span className=" fw-bolder">Healthcare</span>. Simplified
              Management.
            </h1>

            <p className="mt-3 text-dark" data-aos="zoom-in">
              Streamline hospital operations, enhance patient care, and manage
              everything from appointments to billing with our all-in-one
              hospital management system.
            </p>

            <div className="row mt-4 g-3">
              <div className="col-6 col-md-3" data-aos="zoom-in">
                <div className="bg-white text-dark text-center p-3 rounded shadow border-4 border-top border-danger">
                  <Users
                    size={28}
                    className="mb-2 lanp-secondary-text fw-bold"
                  />
                  <h5 className="fw-bold mb-0">1000+</h5>
                  <small>Hospitals Served</small>
                </div>
              </div>

              <div className="col-6 col-md-3" data-aos="zoom-in">
                <div className="bg-white text-dark text-center p-3 rounded shadow border-4 border-top border-danger ">
                  <Award
                    size={28}
                    className="mb-2 lanp-secondary-text fw-bold"
                  />
                  <h5 className="fw-bold mb-0">200+</h5>
                  <small>Expert Team</small>
                </div>
              </div>

              <div className="col-6 col-md-3" data-aos="zoom-in">
                <div className="bg-white text-dark text-center p-3 rounded shadow border-4 border-top border-danger">
                  <Activity
                    size={28}
                    className="mb-2 lanp-secondary-text fw-bold"
                  />
                  <h5 className="fw-bold mb-0">15+</h5>
                  <small>Years Experience</small>
                </div>
              </div>

              <div className="col-6 col-md-3" data-aos="zoom-in">
                <div className="bg-white text-dark text-center p-3 rounded shadow border-4 border-top border-danger">
                  <CheckCircle
                    size={28}
                    className="mb-2 lanp-secondary-text fw-bold"
                  />
                  <h5 className="fw-bold mb-0">99%</h5>
                  <small>Client Satisfaction</small>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-5" data-aos="zoom-in" id="enquirynow">
            <div className="bg-white text-dark p-4 rounded-4 shadow border-4 border-top border-danger">
              <h4 className="fw-bold text-center">Register for a Free Trial</h4>
              <hr />
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-lg-6 col-12 mb-2">
                    <label className="form-label">Doctor/Hospital Name</label>
                    <input
                      {...register("doctorName")}
                      type="text"
                      className="form-control"
                      placeholder="Doctor/Hospital Name"
                    />
                    {errors.doctorName &&
                      <p className="text-danger">
                        {errors.doctorName.message}
                      </p>}
                  </div>
                  <div className="col-lg-6 col-12 mb-2">
                    <label className="form-label">Speciality</label>
                    <select className="form-select" {...register("speciality")}>
                      <option value="">Please Select</option>
                      <option>Speciality</option>
                      <option>Multi-Specialty</option>
                      <option>Cardiology</option>
                      <option>Dermatology & Cosmetic</option>
                      <option>Neurology</option>
                      <option>Family Practice</option>
                      <option>Urology</option>
                    </select>
                    {errors.speciality &&
                      <p className="text-danger">
                        {errors.speciality.message}
                      </p>}
                  </div>
                  <div className="col-lg-6 col-12 mb-2">
                    <label className="form-label">Mobile Number</label>
                    <div className="input-group">
                      <span className="input-group-text">+91</span>
                      <input
                        {...register("mobile")}
                        type="text"
                        className="form-control"
                        placeholder="Mobile Number"
                      />
                    </div>
                    {errors.mobile &&
                      <p className="text-danger">
                        {errors.mobile.message}
                      </p>}
                  </div>
                  <div className="col-lg-6 col-12 mb-2">
                    <label className="form-label">Business Type</label>
                    <select
                      className="form-select"
                      {...register("businessType")}
                    >
                      <option value="">Please Select</option>
                      <option>Hospital/Laboratory/Polyclinic</option>
                      <option>Hospital Management Software (HMS)</option>
                      <option>Clinic Management Software (CMS)</option>
                      <option>Laboratory Management Software (LIMS)</option>
                      <option>Pharmacy Management Software</option>
                      <option>Medical College & Hospital</option>
                      <option>Consultant</option>
                    </select>
                    {errors.businessType &&
                      <p className="text-danger">
                        {errors.businessType.message}
                      </p>}
                  </div>
                  <div className="col-lg-6 col-12 mb-2">
                    <label className="form-label">Email ID</label>
                    <input
                      {...register("email")}
                      type="email"
                      className="form-control"
                      placeholder="Email ID"
                    />
                    {errors.email &&
                      <p className="text-danger">
                        {errors.email.message}
                      </p>}
                  </div>
                  <div className="col-lg-6 col-12 mb-2">
                    <label className="form-label">Website (If Available)</label>
                    <input
                      {...register("website")}
                      type="text"
                      className="form-control"
                      placeholder="Website (If Available)"
                    />
                    {errors.website &&
                      <p className="text-danger">
                        {errors.website.message}
                      </p>}
                  </div>
                  <div className="col-12 mb-2">
                    <label className="form-label">Message</label>
                    <textarea
                      {...register("message")}
                      className="form-control"
                      rows="1s"
                      placeholder="Your Message"
                    />
                    {errors.message &&
                      <p className="text-danger">
                        {errors.message.message}
                      </p>}
                  </div>
                  <div className="col-12 mb-2">
                    <div className="form-check">
                      <input
                        id="terms"
                        className="form-check-input"
                        type="checkbox"
                        {...register("terms")}
                      />
                      <label className="form-check-label small" htmlFor="terms">
                        I accept the terms and conditions.
                      </label>
                    </div>
                    {errors.terms &&
                      <p className="text-danger">
                        {errors.terms.message}
                      </p>}
                  </div>
                  <div className="col-12">
                    <button
                      className="btn lanp-btn-primary w-100 text-white rounded-pill"
                      disabled={loading}
                    >
                      {loading
                        ? <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          />
                        : "Start Free Trial"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
